import React from "react"
import { Avatar } from "@mui/material"
import { BORDERRADIUS as borderRadius } from "@fedsim/constants"

export function ImageBlock({
	children = null,
	image = "",
	name = "",
	backgroundColor = null,
	variant = "rounded",
	size = null,
	height = "140px",
	width = "120px",
	...rest
}) {
	const bgcolor = backgroundColor || ""
	return (
		<Avatar
			variant={variant}
			src={image}
			alt={name}
			sx={{
				bgcolor,
				width: size || width,
				height: size || height,
				borderRadius
			}}
			{...rest}
		>
			{children}
		</Avatar>
	)
}

export default ImageBlock;